@if ({
  ticket: ticket$ | async
}; as vm) {
  <app-view-dashboard-component>
    <div modalTitle>
      {{ 'calendar.site.name' | translate }}
    </div>
  </app-view-dashboard-component>
}